<template>
  <modal titulo="Cancelar Ordem">

    <card>
      <form @submit.prevent="" class="row gutters-xs form">
        <v-input type="textarea" label="Motivo" class="col-12" :error="validation.motivoCancelamento" v-model="form.motivoCancelamento" />
      </form>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Fechar</button>
      <v-button :run="run" class="btn-outline-primary" :popover="true">Salvar</v-button>
    </template>

  </modal>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness.js";
  import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness.js";
  import Card from "@/components/Layout/components/Card.vue";
  import Modal from "@/components/Modal";

  export default {
    name: "ModalCancelarOrdem",
    components: {Card, Modal},

    props: {
      id: String,
    },

    data() {
      return {
        form: { motivoCancelamento : '' },
        validation: { motivoCancelamento: null }
      }
    },

    methods: {

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '');
      },

      close(r) {
        FrontBusiness.closeModal(r);
      },

      async run() {
        this.$set(this, 'validation', {});
        if(!this.form.motivoCancelamento.length) {
          return this.$set(this.validation, 'motivoCancelamento', 'Campo Obrigatório');
        }
        let dto = {
          motivoCancelamento: this.form.motivoCancelamento,
        }

        let retorno = await IndisponibilidadeBusiness
          .cancelarOrdem(this.id, dto)
          .catch(this.showError);

        if(retorno){
          FrontBusiness.showSuccess('', 'Ordem cancelada');
          this.close(true);
        }
      },

    }

  }
</script>
